import api from '../instance';

export type TFortuneResponse = {
  branch: string;
  experiment: string;
  is_experiment: boolean;
};

export default {
  getExperimentBranch: (experimentName: string, userId: string): Promise<TFortuneResponse> =>
    api.get(`fortune/${experimentName}`, { params: { user_id: userId } }),
};
